import script from "./InvoiceNeedingReminderRow.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceNeedingReminderRow.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceNeedingReminderRow.vue?vue&type=style&index=0&id=52210977&lang=css"

const __exports__ = script;

export default __exports__